/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit, omitBy } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    PAYMENT_METHODS_RECEIVE,
    PAYMENT_METHODS_REQUEST,
    PAYMENT_METHODS_REQUEST_SUCCESS,
    PAYMENT_METHODS_REQUEST_FAILURE,
    PAYMENT_METHODS_REMOVE_SUCCESS,
} from 'state/action-types';

export const items = createReducer([], {
    [PAYMENT_METHODS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, paymentMethods) => {
                const { id } = paymentMethods;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = paymentMethods;
                return memo;
            },
            state,
        );
    },
    [PAYMENT_METHODS_REMOVE_SUCCESS]: (state, action) => {
        const paymentMethodId = get(action, ['payload', ['paymentMethodId']]);
        const items = { ...state };
        return omitBy(items, { id: paymentMethodId });
    },
});

export const requesting = createReducer(false, {
    [PAYMENT_METHODS_REQUEST]: () => true,
    [PAYMENT_METHODS_REQUEST_SUCCESS]: () => false,
    [PAYMENT_METHODS_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [PAYMENT_METHODS_REQUEST]: () => false,
    [PAYMENT_METHODS_REQUEST_SUCCESS]: () => false,
    [PAYMENT_METHODS_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error,
});
